// extracted by mini-css-extract-plugin
module.exports = {"block":"Mission_block__3ReGq","blockText":"Mission_blockText__2se6_"};